import { Stack } from "expo-router";
import { authScreens } from "../../src/constants/auth-screen";

export default function AuthLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      {authScreens.map((screen) => (
        <Stack.Screen key={screen.name} name={screen.name} />
      ))}
    </Stack>
  );
}
